import React from 'react';

const LIST_ICON_MASK = `url(${process.env.PUBLIC_URL || ''}/List.svg)`;

const ListIcon: React.FC = () => (
  <span
    className="cp-list-icon"
    aria-hidden
    style={{ WebkitMaskImage: LIST_ICON_MASK, maskImage: LIST_ICON_MASK }}
  />
);

export default ListIcon;
